import Vue from 'vue';

import { routeNames } from '../../config/router/routeNames';

Vue.mixin({
    data() {
        return {
            routeName: routeNames,
        };
    },
});
